export const EncounterType = {
  FACE_TO_FACE: {
    value: 'FACE_TO_FACE',
    displayName: 'Face to face'
  },
  TELEPHONE: {
    value: 'TELEPHONE',
    displayName: 'Telephone'
  }
};
